// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7c12e6df","977":"29dd59a5"}[chunkId] + ".chunk.js";
};